import React from "react";
import HyperText from "../assests/HyperText.png";
import cascading from "../assests/cascading.png";
import JS from "../assests/JS.png";
import ReactImage from "../assests/ReactImage.png";
import tailwind from "../assests/tailwind.jpeg";
import python from "../assests/python.png";
import git from "../assests/git.png";
import github from "../assests/github.png";
import flask from "../assests/flask.png";


const Skills = () => {
  const techs = [
    {
      id: 1,
      src: HyperText,
      title: "HTML",
      style: "shadow-orange-500",
    },
    {
      id: 2,
      src: cascading,
      title: "CSS",
      style: "shadow-blue-500",
    },
    {
      id: 3,
      src: JS,
      title: "JavaScript",
      style: "shadow-yellow-500",
    },
    {
      id: 4,
      src: ReactImage,
      title: "React",
      style: "shadow-blue-600",
    },
    {
      id: 5,
      src: tailwind,
      title: "Tailwind",
      style: "shadow-sky-400",
    },
    {
      id: 6,
      src: python,
      title: "Python",
      style: "shadow-sky-400",
    },
    {
      id: 7,
      src: git,
      title: "Git",
      style: "shadow-orange-500",
    },
    {
      id: 8,
      src: github,
      title: "Github",
      style: "shadow-gray-500",
    },
    {
      id: 9,
      src: flask,
      title: "Flask",
      style: "shadow-gray-500",
    },
  ];

  return (
    <div
      name="Skills"
      id="Skills"
      className="bg-gradient-to-b from-gray-800 to-black w-full min-h-screen"
    >
      <div className="max-w-screen-lg mx-auto p-4 flex flex-col justify-center w-full h-full text-white">
        <div>
          <p className="text-3xl md:text-4xl font-bold border-b-4 border-gray-500 p-2 inline">
            Skills
          </p>
          <p className="py-4 md:py-6 text-base md:text-lg">
            Here is the few technologies I've been working recently:
            </p>
        </div>

        <div className="w-full grid grid-cols-2 sm:grid-cols-3 gap-4 sm:gap-6 text-center py-8 px-4 sm:px-0">
          {techs.map(({ id, src, title, style }) => (
            <div key ={id} className={`shadow-md hover:scale-105 transition-transform duration-500 py-4 rounded-lg ${style}`}>
              <img src={src} alt="" className="w-16 h-16 mx-auto bg-gradient-to-b from -gray-800" />
              <p className="mt-2 text-sm md:text-lg">{title}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Skills;
